import { types, actions } from './requests'
export const CLIENTORDERLISTSTATE_TYPES = {
    ...types('CLIENTORDERLISTSTATE'),
}
export const CLIENTORDERLISTSTATE_ACTIONS = {
    ...actions('CLIENTORDERLISTSTATE'),
}
